import { SchemaIntersectionTypesError } from '@rehaje/core'

import { SchemaModel } from '../../models'
import { SchemaObjectModel } from '../Schema.Object'

import type { SchemaIntersectionNode } from './TypedNode'

export class SchemaIntersectionModel extends SchemaModel {
  override joinChildrenValuePath(child: SchemaModel) {
    if (child instanceof SchemaObjectModel) return this.valuePath
    throw new SchemaIntersectionTypesError()
  }

  override render() {
    const node = this.getTypedNode<SchemaIntersectionNode>()
    return super.render(node.types.map((type) => type.render()))
  }
}

declare global {
  export interface RehajeViewModels {
    'Schema.Intersection': SchemaIntersectionModel
  }
}
